/*============ Company Controller
 ================================*/
angular
        .module('vppApp')
        .controller('companyController', companyController);

companyController.$inject = ['$scope', 'vppConfig', 'apiFactory', '$state', '$log'];

function companyController($scope, vppConfig, apiFactory, $state, $log) {

  $scope.submitCompany = function (companyName) {
    $scope.responsePending = true;
    apiFactory.company(companyName)
      .then(function company(response) {
        $scope.serverError = '';
        $scope.responsePending = false;
        $scope.companies = response.data.companyParts;
        if($scope.companies.length > 3){
          $scope.adLeft = true;
        } else {
          $scope.adLeft = false;
        }
      }, function errorCallback(response) {
        $scope.responsePending = false;
        $scope.serverError = response.data.errors;
      });
  };
};